import { motion } from "framer-motion";
import { content } from "../../data/content";
import { Reveal } from "./Reveal";

const MINI_ROT = ["-3deg", "2deg", "3deg", "-2deg"];

function Collage({ minis }) {
  return (
    <div className="w-full aspect-[4/5] bg-[#f3f1ea] border-2 border-ink p-2 grid grid-cols-2 grid-rows-2 gap-2 overflow-hidden">
      {minis.slice(0, 4).map((src, i) => (
        <div
          key={i}
          className="bg-white p-1 pb-2 border border-ink shadow-[1px_2px_0_rgba(28,25,23,0.3)] overflow-hidden"
          style={{ transform: `rotate(${MINI_ROT[i % MINI_ROT.length]})` }}
        >
          <img
            src={src}
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
}

function Polaroid({ item, index }) {
  return (
    <motion.figure
      data-testid={`gallery-photo-${index}`}
      style={{ rotate: item.rotate }}
      whileHover={{ rotate: 0, scale: 1.04, zIndex: 20 }}
      transition={{ type: "spring", stiffness: 200, damping: 14 }}
      className="relative bg-white border-[3px] border-ink shadow-brutal-lg p-3 pb-12 w-60 sm:w-64 md:w-72 cursor-pointer"
    >
      {item.type === "collage" ? (
        <Collage minis={item.minis} />
      ) : (
        <div className="w-full aspect-[4/5] bg-[#f3f1ea] border-2 border-ink flex items-center justify-center overflow-hidden">
          <img
            src={item.url}
            alt={item.caption}
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>
      )}
      <figcaption className="font-accent text-2xl md:text-3xl text-ink absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap">
        {item.caption}
      </figcaption>
    </motion.figure>
  );
}

export function Gallery() {
  return (
    <section
      data-testid="gallery-section"
      className="relative w-full bg-lilac px-5 md:px-10 py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-14 md:mb-20">
          <p className="font-accent text-3xl md:text-5xl text-grape -rotate-2">
            {content.galleryTitle}
          </p>
        </Reveal>

        <div className="flex flex-wrap justify-center items-start gap-8 md:gap-12">
          {content.gallery.map((item, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <Polaroid item={item} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
